"use strict";
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var MAX_LENGTH = require("../internal/constants").MAX_LENGTH;
var ref = require("../internal/re"), re = ref.re, t = ref.t;
var SemVer = require("../classes/semver");
var parseOptions = require("../internal/parse-options");
var parse = function(version, options) {
    options = parseOptions(options);
    if (_instanceof(version, SemVer)) {
        return version;
    }
    if (typeof version !== "string") {
        return null;
    }
    if (version.length > MAX_LENGTH) {
        return null;
    }
    var r = options.loose ? re[t.LOOSE] : re[t.FULL];
    if (!r.test(version)) {
        return null;
    }
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
};
module.exports = parse;
